// src/components/SiteContextEditor.tsx

import React from 'react'
import { FileText } from 'lucide-react'
import MarkdownEditor from './MarkdownEditor'

type SiteContextEditorProps = {
  value: string
  onChange: (value: string) => void
  className?: string
  minRows?: number
  maxRows?: number
  disabled?: boolean
}

export const SiteContextEditor: React.FC<SiteContextEditorProps> = ({
  value,
  onChange,
  className = '',
  minRows = 8,
  maxRows = 24,
  disabled = false,
}) => {
  return (
    <section className={`card p-4 md:p-6 flex flex-col gap-4 ${className}`}>
      <div className="flex items-center gap-2 mb-1">
        <FileText className="w-5 h-5 text-brixel" />
        <span className="font-semibold text-gray-900">
          Contexte global du site
        </span>
      </div>
      <MarkdownEditor
        value={value}
        onChange={onChange}
        placeholder="Décrivez le contexte global de votre site (présentation, objectifs, informations générales)…"
        minRows={minRows}
        maxRows={maxRows}
        disabled={disabled}
      />
    </section>
  )
}

export default SiteContextEditor